import { useState, useEffect } from "react";
import { signUp } from "../auth";
import { supabase } from "../supabase";

const conversations = [
  { name: "Fatima", channel: "WhatsApp", avatarBg: "#25D366", msgs: [
    { t: "Bonjour, vous avez des abayas ?", c: "client" },
    { t: "Oui ! À 35 000 FCFA du S au XXL 😊 Quelle taille ?", c: "ai", cls: "wa" },
  ]},
  { name: "sara_mode", channel: "Instagram", avatarBg: "#E1306C", msgs: [
    { t: "C'est combien ce hijab ? 😍", c: "client" },
    { t: "8 000 FCFA en 12 couleurs ✨ Laquelle vous tente ?", c: "ai", cls: "ig" },
  ]},
  { name: "Karim", channel: "Facebook", avatarBg: "#0084FF", msgs: [
    { t: "Vous livrez à Dakar ?", c: "client" },
    { t: "Oui, 48-72h à Dakar 🚚 Qu'est-ce qui vous intéresse ?", c: "ai", cls: "fb" },
  ]},
];

const aiBg = { wa: "#25D366", ig: "#E1306C", fb: "#0084FF" };

function AnimatedMessages({ small }) {
  const [messages, setMessages] = useState([]);
  const [convIdx, setConvIdx] = useState(0);
  const [visible, setVisible] = useState([]);

  useEffect(() => {
    const conv = conversations[convIdx];
    setMessages(conv.msgs);
    setVisible([]);
    conv.msgs.forEach((_, i) => {
      setTimeout(() => setVisible(prev => [...prev, i]), 200 + i * 500);
    });
  }, [convIdx]);

  useEffect(() => {
    const interval = setInterval(() => {
      setConvIdx(prev => (prev + 1) % conversations.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const conv = conversations[convIdx];
  const fs = small ? "10px" : "11px";
  const pad = small ? "6px 9px" : "8px 12px";
  const avSize = small ? "22px" : "26px";
  const avFs = small ? "9px" : "10px";

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: small ? "7px" : "10px" }}>
      {messages.map((m, i) => (
        <div key={`${convIdx}-${i}`} style={{
          display: "flex", alignItems: "flex-end", gap: "8px",
          flexDirection: m.c === "ai" ? "row-reverse" : "row",
          opacity: visible.includes(i) ? 1 : 0,
          transform: visible.includes(i) ? "translateY(0)" : "translateY(10px)",
          transition: "all 0.4s ease",
        }}>
          <div style={{
            width: avSize, height: avSize, borderRadius: "50%",
            background: m.c === "ai" ? conv.avatarBg : "#444",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: avFs, fontWeight: "600", color: "#fff", flexShrink: 0,
          }}>
            {m.c === "ai" ? "IA" : conv.name[0]}
          </div>
          <div>
            {i === 0 && (
              <div style={{ fontSize: "8px", color: "#666", marginBottom: "3px" }}>
                {m.c === "ai" ? conv.channel : conv.name}
              </div>
            )}
            <div style={{
              padding: pad,
              borderRadius: m.c === "client" ? "4px 12px 12px 12px" : "12px 4px 12px 12px",
              background: m.c === "client" ? "#2a2a2a" : aiBg[m.cls],
              color: "#fff", fontSize: fs, lineHeight: "1.4",
              maxWidth: small ? "180px" : "220px",
            }}>
              {m.t}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

function LeftPanel({ small }) {
  return (
    <div style={{
      flex: 1, minWidth: small ? "100%" : "50%",
      background: "#0f0f0f",
      padding: small ? "28px 24px 24px" : "40px",
      display: "flex", flexDirection: "column",
      justifyContent: "space-between",
      position: "relative", overflow: "hidden", flexShrink: 0
    }}>
      <div style={{ position: "absolute", width: small ? "200px" : "350px", height: small ? "200px" : "350px", borderRadius: "50%", background: "#C04828", filter: "blur(70px)", opacity: 0.25, top: "-80px", left: "-40px" }} />
      <div style={{ position: "absolute", width: small ? "150px" : "250px", height: small ? "150px" : "250px", borderRadius: "50%", background: "#FF6B3D", filter: "blur(60px)", opacity: 0.2, bottom: "-60px", right: "-40px" }} />

      <div style={{ display: "flex", alignItems: "center", gap: "10px", position: "relative", zIndex: 1, marginBottom: small ? "16px" : 0 }}>
        <div style={{ width: small ? "30px" : "34px", height: small ? "30px" : "34px", background: "linear-gradient(135deg,#C04828,#FF6B3D)", borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <span style={{ color: "#fff", fontWeight: "500", fontSize: small ? "11px" : "12px" }}>SC</span>
        </div>
        <span style={{ color: "#fff", fontWeight: "500", fontSize: small ? "14px" : "15px" }}>Smart CRM</span>
      </div>

      <div style={{ position: "relative", zIndex: 1, flex: small ? 0 : 1, display: "flex", flexDirection: "column", justifyContent: "center", gap: small ? "14px" : "32px", padding: small ? 0 : "40px 0" }}>
        <div style={{ color: "#fff", fontSize: small ? "16px" : "26px", fontWeight: "500", lineHeight: "1.35", letterSpacing: "-0.3px" }}>
          Votre business répond, vend et encaisse...<br />
          <span style={{ color: "#FF6B3D" }}>même quand vous dormez.</span>
        </div>
        <AnimatedMessages small={small} />
      </div>

      {!small && (
        <div style={{ position: "relative", zIndex: 1 }}>
          <p style={{ color: "#555", fontSize: "11px" }}>Rejoignez <span style={{ color: "#888" }}>+500 business</span> qui automatisent leurs ventes</p>
        </div>
      )}
    </div>
  );
}

export default function Register({ onRegister, goToLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

async function handleSubmit(e) {
  e.preventDefault();
  setLoading(true);
  setError("");

  if (password.length < 6) {
    setError("Le mot de passe doit contenir au moins 6 caractères");
    setLoading(false);
    return;
  }

  const { data, error } = await signUp(email, password, businessName);

  if (error) {
    setError(error.message);
    setLoading(false);
    return;
  }

  // Récupérer l'utilisateur — Supabase peut le retourner de 2 façons
  const user = data?.user || data?.session?.user;

  if (user) {
    const trialExpires = new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString();

    const { error: orgError } = await supabase
      .from('organizations')
      .insert({
        name: businessName,
        user_id: user.id,
        plan_name: 'trial',
        is_trial: true,
        is_active: true,
        trial_started_at: new Date().toISOString(),
        trial_expires_at: trialExpires,
        trial_messages_limit: 100,
        trial_messages_used: 0,
        messages_limit: 0,
        messages_used: 0,
        subscription_plan: 'trial',
        subscription_status: 'trial'
      });

    if (orgError) {
      console.error('Erreur création organisation:', orgError);
    }
  }

  setSuccess(true);
  setLoading(false);
}

  const inputStyle = {
    width: "100%", padding: "10px 12px",
    border: "0.5px solid var(--color-border-secondary)",
    borderRadius: "8px", fontSize: "13px",
    color: "var(--color-text-primary)",
    background: "var(--color-background-primary)", outline: "none",
  };

  if (success) {
    return (
      <div style={{ minHeight: "100vh", background: "var(--color-background-primary)", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}>
        <div style={{ textAlign: "center", maxWidth: "360px" }}>
          <div style={{ width: "56px", height: "56px", background: "#22c55e", borderRadius: "16px", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", fontSize: "24px" }}>✓</div>
          <div style={{ fontSize: "20px", fontWeight: "500", color: "var(--color-text-primary)", marginBottom: "8px" }}>Compte créé !</div>
          <p style={{ fontSize: "13px", color: "var(--color-text-secondary)", marginBottom: "24px" }}>
            Vérifiez votre email pour confirmer votre compte puis connectez-vous.
          </p>
          <button onClick={goToLogin} style={{ padding: "10px 24px", background: "#C04828", color: "#fff", border: "none", borderRadius: "8px", fontSize: "13px", fontWeight: "500", cursor: "pointer" }}>
            Se connecter
          </button>
        </div>
      </div>
    );
  }

  const WHATSAPP_LINK = "https://wa.me/212663820033?text=HELLODIA";

const formPanel = (
  <div style={{ width: isMobile ? "100%" : "50%", minWidth: isMobile ? "100%" : "50%", background: "var(--color-background-primary)", padding: isMobile ? "24px" : "40px", display: "flex", flexDirection: "column", justifyContent: "center" }}>

    <div style={{ display: "flex", background: "var(--color-background-secondary)", borderRadius: "8px", padding: "3px", marginBottom: "24px", border: "0.5px solid var(--color-border-tertiary)" }}>
      <button onClick={goToLogin} style={{ flex: 1, padding: "7px", borderRadius: "6px", fontSize: "13px", fontWeight: "500", border: "none", cursor: "pointer", background: "transparent", color: "var(--color-text-secondary)" }}>Connexion</button>
      <button style={{ flex: 1, padding: "7px", borderRadius: "6px", fontSize: "13px", fontWeight: "500", border: "none", cursor: "pointer", background: "#C04828", color: "#fff" }}>Créer un compte</button>
    </div>

    <div style={{ fontSize: "18px", fontWeight: "500", color: "var(--color-text-primary)", marginBottom: "3px" }}>Créer votre compte</div>
    <div style={{ fontSize: "13px", color: "var(--color-text-secondary)", marginBottom: "20px" }}>Votre assistant prêt en 5 minutes</div>

    {/* Bouton WhatsApp direct */}
    <a href={WHATSAPP_LINK} target="_blank" rel="noreferrer" style={{ display: "block", textDecoration: "none", marginBottom: "16px" }}>
      <div style={{ width: "100%", padding: "12px", background: "#25D366", color: "#fff", border: "none", borderRadius: "8px", fontSize: "13px", fontWeight: "500", cursor: "pointer", textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
        Configurer directement via WhatsApp
      </div>
    </a>

    <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "16px" }}>
      <div style={{ flex: 1, height: "0.5px", background: "var(--color-border-tertiary)" }} />
      <span style={{ fontSize: "12px", color: "var(--color-text-tertiary)" }}>ou créer un compte</span>
      <div style={{ flex: 1, height: "0.5px", background: "var(--color-border-tertiary)" }} />
    </div>

    <form onSubmit={handleSubmit}>
      <div style={{ marginBottom: "14px" }}>
        <label style={{ fontSize: "12px", fontWeight: "500", color: "var(--color-text-secondary)", marginBottom: "5px", display: "block" }}>Nom du business</label>
        <input type="text" value={businessName} onChange={e => setBusinessName(e.target.value)} placeholder="Ex: Boutique Yasmine" required style={inputStyle} />
      </div>
      <div style={{ marginBottom: "14px" }}>
        <label style={{ fontSize: "12px", fontWeight: "500", color: "var(--color-text-secondary)", marginBottom: "5px", display: "block" }}>Email</label>
        <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="votre@email.com" required style={inputStyle} />
      </div>
      <div style={{ marginBottom: "14px" }}>
        <label style={{ fontSize: "12px", fontWeight: "500", color: "var(--color-text-secondary)", marginBottom: "5px", display: "block" }}>Mot de passe</label>
        <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Minimum 6 caractères" required style={inputStyle} />
        <p style={{ fontSize: "11px", color: "var(--color-text-tertiary)", marginTop: "4px" }}>Minimum 6 caractères</p>
      </div>
      {error && <div style={{ fontSize: "12px", color: "#dc2626", background: "#fef2f2", padding: "8px 12px", borderRadius: "8px", marginBottom: "12px" }}>{error}</div>}
      <button type="submit" disabled={loading} style={{ width: "100%", padding: "11px", background: "#C04828", color: "#fff", border: "none", borderRadius: "8px", fontSize: "13px", fontWeight: "500", cursor: "pointer" }}>
        {loading ? "Création..." : "Créer mon compte gratuitement"}
      </button>
    </form>
  </div>
);

  if (isMobile) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", overflowX: "hidden" }}>
        <LeftPanel small={true} />
        {formPanel}
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", display: "flex", overflowX: "hidden" }}>
      <LeftPanel small={false} />
      {formPanel}
    </div>
  );
}